import { debounce } from 'es-toolkit';
import { startTransition, useEffect, useMemo, useState } from 'react';

export const useDebouncedValue = <T>(value: T, delay = 500) => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  const debounced = useMemo(
    () =>
      debounce((value: T) => {
        // useSuspenseQuery 키 변경으로 재서스펜드돼도 기존 화면(검색 인풋 포함)을 유지
        startTransition(() => {
          setDebouncedValue(value);
        });
      }, delay),
    [delay],
  );

  useEffect(() => {
    debounced(value);

    return debounced.cancel;
  }, [value, debounced]);

  return debouncedValue;
};
